import { c as _c } from "react/compiler-runtime";
import { Button, Input } from '@common/components';
import { useToast } from '@common/hooks';
import SvgChevronleft from '@common/icon/SvgChevronleft';
import SvgDelete from '@common/icon/SvgDelete';
import SvgExpandWindow from '@common/icon/SvgExpandWindow';
import SvgHome from '@common/icon/SvgHome';
import SvgKebab from '@common/icon/SvgKebab';
import SvgLogo from '@common/icon/SvgLogo';
import SvgMagnifyingGlass from '@common/icon/SvgMagnifyingGlass';
import SvgMyFill from '@common/icon/SvgMyFill';
import SvgNotification from '@common/icon/SvgNotification';
import SvgSetting from '@common/icon/SvgSetting';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { type ReactNode, useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { CustomLink } from '@/app/_components/CustomLink';
import { openShareDrawer } from '@/app/_components/GlobalModal/_components/ShareDrawer';
import { shouldShowMobileTrendKeyword } from '@/app/_components/TrendKeyword/constants';
import { TrendKeywordBar } from '@/app/_components/TrendKeyword/TrendKeywordBar';
import SmallLogo from '@/assets/svgs/small_logo.svg';
import { DONATION_ROUTES, MODULE_ROUTES, ROUTES, SUB_DOMAIN } from '@/constants';
import { useCheckKakaobank } from '@/hooks/useCheckKakaobank';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { usePartnerChromeClassName } from '@/hooks/usePartnerChromeClassName';
import { KakaobankExitConfirmModal } from '@/modules/kakaobank/_components/KakaobankExitConfirmModal';
import { requestKakaobankClose } from '@/modules/kakaobank/_utils/appBridge';
import { KAKAOBANK_NAV_SUBTITLE, resolveKakaobankNavTitle } from '@/modules/kakaobank/_utils/navTitle';
import { TossExitConfirmModal, useTossWebView } from '@/modules/toss';
import type { FlutterInAppWebViewWindow } from '@/modules/wello-app';
import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
import { useKakaobankExitStore } from '@/stores/KakaobankExitStore';
import { findRoute } from '@/utils';
import { gtmDatasets } from '@/utils/analytics/gtm';
import { Image } from '../Image/Image';
const TOSS_LOGO_URL = 'https://cdn.welfarehello.com/static/toss-logo.png';
type NavigationRouter = Pick<ReturnType<typeof useCustomRouter>, 'push' | 'replace' | 'back'>;
export type PageNavigationContentProps = PageNavigationProps & {
  isToss: boolean;
  isKakaobank: boolean;
  isLogin?: boolean;
  pathname: string;
  router: NavigationRouter;
  openConfirmModal: VoidFunction;
  closeConfirmModal: VoidFunction;
  confirmAndClose: VoidFunction;
  isModalOpened: boolean;
};
const PageNavigationContent = t0 => {
  const $ = _c(141);
  const {
    logo,
    logoHref,
    title,
    titleLeft,
    children,
    backButton: t1,
    backButtonType: t2,
    searchButton,
    bellButton,
    notification,
    shareButton,
    settingsButton,
    kebabButton,
    onClickBack,
    onClickKebab,
    hideHomeButton,
    className,
    style,
    textColor,
    isNotUsedHomeButton,
    donationHomeButton,
    searchForm,
    searchFormDefaultValue,
    searchFormClassName,
    onSearchFormMount,
    onSearchFormClick,
    onSearchFormSubmit,
    isToss,
    isKakaobank,
    isLogin,
    pathname,
    router,
    openConfirmModal,
    closeConfirmModal,
    confirmAndClose,
    isModalOpened
  } = t0;
  const backButton = t1 === undefined ? true : t1;
  const backButtonType = t2 === undefined ? "back" : t2;
  const partnerChromeClassName = usePartnerChromeClassName();
  const hasBottomNav = findRoute(pathname)?.hasBottomNav;
  const [isKakaobankExitOpened, openKakaobankExit, closeKakaobankExit] = useKakaobankExitStore(useShallow(_temp));
  const {
    toast
  } = useToast();
  let t3;
  if ($[0] !== closeKakaobankExit || $[1] !== toast) {
    t3 = () => {
      try {
        requestKakaobankClose();
      } catch {
        closeKakaobankExit();
        toast({
          type: "fail",
          message: "\uC9C0\uAE08\uC740 \uC885\uB8CC\uD560 \uC218 \uC5C6\uC5B4\uC694. \uCE74\uCE74\uC624\uBC45\uD06C \uC571\uC744 \uCD5C\uC2E0 \uBC84\uC804\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8\uD574\uC8FC\uC138\uC694."
        });
      }
    };
    $[0] = closeKakaobankExit;
    $[1] = toast;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleKakaobankClose = t3;
  const DEFAULT_LOGO_HREF = isToss ? DONATION_ROUTES.HOME.pathname : ROUTES.HOME.pathname;
  let t4;
  if ($[3] !== isKakaobank || $[4] !== onClickBack || $[5] !== router) {
    t4 = onClickBack ? typeof onClickBack === "string" ? () => router.replace(onClickBack) : onClickBack : () => router.back(isKakaobank ? DONATION_ROUTES.HOME.pathname : undefined);
    $[3] = isKakaobank;
    $[4] = onClickBack;
    $[5] = router;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleBack = t4;
  const backFallbackHref = typeof onClickBack === "string" ? onClickBack : pathname.startsWith(DONATION_ROUTES.HOME.pathname) ? DONATION_ROUTES.HOME.pathname : ROUTES.HOME.pathname;
  if (isKakaobank) {
    let t5;
    if ($[7] !== pathname) {
      t5 = DONATION_ROUTES.HOME.isMatchPathname(pathname);
      $[7] = pathname;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    const isDonationHome = t5;
    let t6;
    if ($[9] !== pathname) {
      t6 = DONATION_ROUTES.CALLBACK.isMatchPathname(pathname);
      $[9] = pathname;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    const isDonationCallback = t6;
    let t7;
    if ($[11] !== pathname || $[12] !== title) {
      t7 = resolveKakaobankNavTitle(pathname) ?? title;
      $[11] = pathname;
      $[12] = title;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    const navTitle = t7;
    let t8;
    if ($[14] !== isLogin) {
      t8 = isLogin === false ? ROUTES.LOGIN.withSearchParams({
        searchParams: {
          redirect: DONATION_ROUTES.MY.pathname
        }
      }) : DONATION_ROUTES.MY.pathname;
      $[14] = isLogin;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    const myHref = t8;
    const kakaobankSearchHref = typeof searchButton === "string" ? searchButton : DONATION_ROUTES.SEARCH.pathname;
    let t9;
    bb0: {
      if (isDonationHome) {
        let t10;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = <SvgDelete className="size-24" />;
          $[16] = t10;
        } else {
          t10 = $[16];
        }
        let t11;
        if ($[17] !== openKakaobankExit) {
          t11 = {
            label: "\uCE74\uCE74\uC624\uBC45\uD06C\uB85C \uB3CC\uC544\uAC00\uAE30",
            icon: t10,
            onClick: openKakaobankExit
          };
          $[17] = openKakaobankExit;
          $[18] = t11;
        } else {
          t11 = $[18];
        }
        t9 = t11;
        break bb0;
      }
      if (isDonationCallback) {
        let t10;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = <SvgDelete className="size-24" />;
          $[19] = t10;
        } else {
          t10 = $[19];
        }
        let t11;
        if ($[20] !== handleBack) {
          t11 = {
            label: "\uB2EB\uAE30",
            icon: t10,
            onClick: handleBack
          };
          $[20] = handleBack;
          $[21] = t11;
        } else {
          t11 = $[21];
        }
        t9 = t11;
        break bb0;
      }
      if (backButton) {
        let t10;
        if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
          t10 = <SvgChevronleft className="size-24" />;
          $[22] = t10;
        } else {
          t10 = $[22];
        }
        let t11;
        if ($[23] !== handleBack) {
          t11 = {
            label: "\uB4A4\uB85C \uAC00\uAE30",
            icon: t10,
            onClick: handleBack
          };
          $[23] = handleBack;
          $[24] = t11;
        } else {
          t11 = $[24];
        }
        t9 = t11;
        break bb0;
      }
      t9 = null;
    }
    const leftAction = t9;
    const t10 = isDonationHome ? "pr-8" : "pr-16";
    let t11;
    if ($[25] !== className || $[26] !== partnerChromeClassName || $[27] !== t10) {
      t11 = cn("relative flex min-h-48 w-full items-center justify-between pl-4", t10, "box-border select-none bg-Gray-white text-center", partnerChromeClassName, className);
      $[25] = className;
      $[26] = partnerChromeClassName;
      $[27] = t10;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    let t12;
    if ($[29] !== leftAction) {
      t12 = leftAction ? <Button aria-label={leftAction.label} className="relative size-26 p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H26" theme="primary-text" onClick={leftAction.onClick}>{leftAction.icon}</Button> : null;
      $[29] = leftAction;
      $[30] = t12;
    } else {
      t12 = $[30];
    }
    let t13;
    if ($[31] !== t12) {
      t13 = <div className="grid size-44 shrink-0 place-items-center">{t12}</div>;
      $[31] = t12;
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    let t14;
    if ($[33] !== navTitle) {
      t14 = navTitle ? <h3 className="w-full truncate font-700 text-Gray-900 typo-body3">{navTitle}</h3> : null;
      $[33] = navTitle;
      $[34] = t14;
    } else {
      t14 = $[34];
    }
    let t15;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <p className="font-400 text-Gray-700 typo-caption1">{KAKAOBANK_NAV_SUBTITLE}</p>;
      $[35] = t15;
    } else {
      t15 = $[35];
    }
    let t16;
    if ($[36] !== t14) {
      t16 = <div className="absolute inset-x-0 mx-auto flex w-185 flex-col items-center gap-2 px-8">{t14}{t15}</div>;
      $[36] = t14;
      $[37] = t16;
    } else {
      t16 = $[37];
    }
    let t17;
    if ($[38] !== isDonationCallback || $[39] !== isDonationHome || $[40] !== kakaobankSearchHref || $[41] !== myHref || $[42] !== openKakaobankExit || $[43] !== searchButton) {
      t17 = isDonationHome ? <>{searchButton ? <div className="grid size-44 place-items-center"><Button aria-label={"\uAC80\uC0C9\uC73C\uB85C \uC774\uB3D9"} asChild={true} className="relative size-26 p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H26" theme="primary-text"><CustomLink href={kakaobankSearchHref}><SvgMagnifyingGlass className="size-24" /></CustomLink></Button></div> : null}<div className="grid size-44 place-items-center"><Button aria-label="MY" asChild={true} className="relative size-28 p-0 before:absolute before:-inset-8 before:content-['']" dimensions="H26" theme="primary-text"><CustomLink href={myHref}><SvgMyFill className="size-28 shrink-0" /></CustomLink></Button></div></> : isDonationCallback ? null : <Button aria-label={"\uCE74\uCE74\uC624\uBC45\uD06C\uB85C \uB3CC\uC544\uAC00\uAE30"} className="relative h-26 whitespace-nowrap p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H40" theme="primary-text" onClick={openKakaobankExit}>닫기</Button>;
      $[38] = isDonationCallback;
      $[39] = isDonationHome;
      $[40] = kakaobankSearchHref;
      $[41] = myHref;
      $[42] = openKakaobankExit;
      $[43] = searchButton;
      $[44] = t17;
    } else {
      t17 = $[44];
    }
    let t18;
    if ($[45] !== t17) {
      t18 = <div className="z-[1] flex shrink-0 items-center">{t17}</div>;
      $[45] = t17;
      $[46] = t18;
    } else {
      t18 = $[46];
    }
    let t19;
    if ($[47] !== closeKakaobankExit || $[48] !== handleKakaobankClose || $[49] !== isKakaobankExitOpened) {
      t19 = <KakaobankExitConfirmModal opened={isKakaobankExitOpened} onClose={closeKakaobankExit} onConfirm={handleKakaobankClose} />;
      $[47] = closeKakaobankExit;
      $[48] = handleKakaobankClose;
      $[49] = isKakaobankExitOpened;
      $[50] = t19;
    } else {
      t19 = $[50];
    }
    let t20;
    if ($[51] !== style || $[52] !== t11 || $[53] !== t13 || $[54] !== t16 || $[55] !== t18 || $[56] !== t19) {
      t20 = <nav aria-label={"\uD398\uC774\uC9C0 \uB0B4\uBE44\uAC8C\uC774\uC158"} className={t11} style={style}>{t13}{t16}{t18}{t19}</nav>;
      $[51] = style;
      $[52] = t11;
      $[53] = t13;
      $[54] = t16;
      $[55] = t18;
      $[56] = t19;
      $[57] = t20;
    } else {
      t20 = $[57];
    }
    return t20;
  }
  let t5;
  if ($[58] !== className || $[59] !== partnerChromeClassName) {
    t5 = cn("relative flex min-h-48 w-full items-center", "box-border select-none bg-Gray-white text-center", partnerChromeClassName, className);
    $[58] = className;
    $[59] = partnerChromeClassName;
    $[60] = t5;
  } else {
    t5 = $[60];
  }
  let t6;
  if ($[61] !== textColor || $[62] !== titleLeft) {
    t6 = titleLeft ? <h3 className={cn("absolute left-20 font-700 flex-center typo-h6", textColor)}>{titleLeft}</h3> : null;
    $[61] = textColor;
    $[62] = titleLeft;
    $[63] = t6;
  } else {
    t6 = $[63];
  }
  let t7;
  if ($[64] !== textColor || $[65] !== title) {
    t7 = title ? <h3 className={cn("absolute flex size-full items-center justify-center", "break-all text-center font-600 text-Gray-900 typo-body3", textColor)}>{title}</h3> : null;
    $[64] = textColor;
    $[65] = title;
    $[66] = t7;
  } else {
    t7 = $[66];
  }
  let t8;
  if ($[67] !== DEFAULT_LOGO_HREF || $[68] !== isToss || $[69] !== logo || $[70] !== logoHref) {
    t8 = logo ? <div className="flex items-center gap-12"><div className={cn("flex items-center gap-12", {
        "gap-2": isToss
      })}>{isToss ? <><Image src={TOSS_LOGO_URL} alt="toss" width={31} height={31} /><SvgDelete className="size-20 text-Gray-400" /></> : null}<CustomLink aria-label={"\uC6F0\uB85C"} href={logoHref ?? DEFAULT_LOGO_HREF} {...gtmDatasets.clickGnb({
          menu_name: "\uB85C\uACE0"
        })}>{logo === "symbol" ? <SmallLogo className="size-40" /> : <SvgLogo className="h-29 w-86" />}</CustomLink></div></div> : null;
    $[67] = DEFAULT_LOGO_HREF;
    $[68] = isToss;
    $[69] = logo;
    $[70] = logoHref;
    $[71] = t8;
  } else {
    t8 = $[71];
  }
  let t9;
  if ($[72] !== backButton || $[73] !== backButtonType || $[74] !== backFallbackHref || $[75] !== handleBack || $[76] !== textColor) {
    t9 = backButton ? <Button asChild={true} className="relative size-26 p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H26" theme="primary-text"><a aria-label={"\uB4A4\uB85C \uAC00\uAE30"} href={backFallbackHref} onClick={event => {
        event.preventDefault();
        handleBack();
      }}>{backButtonType === "back" ? <SvgChevronleft className={cn("size-24", textColor)} /> : <SvgDelete className={cn("size-24", textColor)} />}</a></Button> : null;
    $[72] = backButton;
    $[73] = backButtonType;
    $[74] = backFallbackHref;
    $[75] = handleBack;
    $[76] = textColor;
    $[77] = t9;
  } else {
    t9 = $[77];
  }
  let t10;
  if ($[78] !== hasBottomNav || $[79] !== hideHomeButton || $[80] !== isNotUsedHomeButton || $[81] !== router || $[82] !== textColor) {
    t10 = !hasBottomNav && !isNotUsedHomeButton ? <Button aria-label={"\uD648\uC73C\uB85C \uAC00\uAE30"} className={cn("relative size-26 p-0", hideHomeButton && "hidden")} dimensions="H26" theme="primary-text" onClick={() => router.push(ROUTES.HOME.pathname)}><SvgHome className={cn("size-24", textColor)} /></Button> : null;
    $[78] = hasBottomNav;
    $[79] = hideHomeButton;
    $[80] = isNotUsedHomeButton;
    $[81] = router;
    $[82] = textColor;
    $[83] = t10;
  } else {
    t10 = $[83];
  }
  let t11;
  if ($[84] !== donationHomeButton || $[85] !== router || $[86] !== textColor) {
    t11 = donationHomeButton ? <Button aria-label={"\uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80 \uD648\uC73C\uB85C \uAC00\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={() => router.push(DONATION_ROUTES.HOME.pathname)}><SvgHome className={cn("size-24", textColor)} /></Button> : null;
    $[84] = donationHomeButton;
    $[85] = router;
    $[86] = textColor;
    $[87] = t11;
  } else {
    t11 = $[87];
  }
  let t12;
  if ($[88] !== onSearchFormClick || $[89] !== onSearchFormMount || $[90] !== onSearchFormSubmit || $[91] !== searchForm || $[92] !== searchFormClassName || $[93] !== searchFormDefaultValue) {
    t12 = searchForm ? <Input ref={el => {
      if (!el) {
        return;
      }
      onSearchFormMount?.(el);
    }} key={searchFormDefaultValue} type="search" placeholder={"\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694"} dimensions="H40" defaultValue={searchFormDefaultValue} className={cn("my-12 w-full select-text border-none bg-Gray-200 text-Gray-900 placeholder:text-Gray-550 focus:border-none", searchFormClassName)} onClick={() => onSearchFormClick?.()} onKeyDown={e => {
      if (e.key === "Enter") {
        onSearchFormSubmit?.(e.currentTarget.value);
      }
    }} onClear={() => onSearchFormSubmit?.("")} /> : null;
    $[88] = onSearchFormClick;
    $[89] = onSearchFormMount;
    $[90] = onSearchFormSubmit;
    $[91] = searchForm;
    $[92] = searchFormClassName;
    $[93] = searchFormDefaultValue;
    $[94] = t12;
  } else {
    t12 = $[94];
  }
  let t13;
  if ($[95] !== t10 || $[96] !== t11 || $[97] !== t12 || $[98] !== t8 || $[99] !== t9) {
    t13 = <div className="z-[1] flex min-w-0 grow items-center gap-20 pl-20">{t8}{t9}{t10}{t11}{t12}</div>;
    $[95] = t10;
    $[96] = t11;
    $[97] = t12;
    $[98] = t8;
    $[99] = t9;
    $[100] = t13;
  } else {
    t13 = $[100];
  }
  let t14;
  if ($[101] !== searchButton || $[102] !== textColor) {
    t14 = searchButton ? <Button aria-label={"\uAC80\uC0C9\uC73C\uB85C \uC774\uB3D9"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" asChild={true} {...gtmDatasets.clickGnb({
      menu_name: "\uAC80\uC0C9"
    })}><CustomLink href={typeof searchButton === "boolean" ? ROUTES.SEARCH.pathname : searchButton}><SvgMagnifyingGlass className={cn("size-24", textColor)} /></CustomLink></Button> : null;
    $[101] = searchButton;
    $[102] = textColor;
    $[103] = t14;
  } else {
    t14 = $[103];
  }
  let t15;
  if ($[104] !== bellButton || $[105] !== notification || $[106] !== router || $[107] !== textColor) {
    t15 = bellButton ? <Button aria-label={"\uC54C\uB9BC\uC73C\uB85C \uC774\uB3D9"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={() => {
      router.push(ROUTES.PUSH.pathname);
    }}><SvgNotification className={cn("size-24", textColor)} />{notification ? <span className="absolute right-14 top-12 box-content size-4 rounded-pill border-2 border-Gray-100 bg-R-500" /> : null}</Button> : null;
    $[104] = bellButton;
    $[105] = notification;
    $[106] = router;
    $[107] = textColor;
    $[108] = t15;
  } else {
    t15 = $[108];
  }
  let t16;
  if ($[109] !== shareButton || $[110] !== textColor) {
    t16 = shareButton ? <Button aria-label={"\uACF5\uC720\uD558\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={_temp2}><SvgExpandWindow className={cn("size-24", textColor)} /></Button> : null;
    $[109] = shareButton;
    $[110] = textColor;
    $[111] = t16;
  } else {
    t16 = $[111];
  }
  let t17;
  if ($[112] !== router || $[113] !== settingsButton || $[114] !== textColor) {
    t17 = settingsButton ? <Button aria-label={"\uC124\uC815"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={() => router.push(ROUTES.MY_SETTINGS.pathname)}><SvgSetting className={cn("size-24", textColor)} /></Button> : null;
    $[112] = router;
    $[113] = settingsButton;
    $[114] = textColor;
    $[115] = t17;
  } else {
    t17 = $[115];
  }
  let t18;
  if ($[116] !== kebabButton || $[117] !== onClickKebab || $[118] !== textColor) {
    t18 = kebabButton ? typeof kebabButton === "boolean" ? <Button aria-label={"\uB354\uBCF4\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={onClickKebab}><SvgKebab className={cn("size-24", textColor)} /></Button> : kebabButton : null;
    $[116] = kebabButton;
    $[117] = onClickKebab;
    $[118] = textColor;
    $[119] = t18;
  } else {
    t18 = $[119];
  }
  let t19;
  if ($[120] !== closeConfirmModal || $[121] !== confirmAndClose || $[122] !== isModalOpened || $[123] !== isToss || $[124] !== openConfirmModal) {
    t19 = isToss ? <><Button aria-label={"\uD1A0\uC2A4\uB85C \uC774\uB3D9"} className="relative h-26 whitespace-nowrap p-0" dimensions="H40" theme="primary-text" onClick={openConfirmModal}>닫기</Button><TossExitConfirmModal opened={isModalOpened} onClose={closeConfirmModal} onConfirm={confirmAndClose} /></> : null;
    $[120] = closeConfirmModal;
    $[121] = confirmAndClose;
    $[122] = isModalOpened;
    $[123] = isToss;
    $[124] = openConfirmModal;
    $[125] = t19;
  } else {
    t19 = $[125];
  }
  let t20;
  if ($[126] !== children || $[127] !== t14 || $[128] !== t15 || $[129] !== t16 || $[130] !== t17 || $[131] !== t18 || $[132] !== t19) {
    t20 = <div className="z-[1] ml-auto flex shrink-0 items-center justify-end gap-20 px-20">{t14}{t15}{children}{t16}{t17}{t18}{t19}</div>;
    $[126] = children;
    $[127] = t14;
    $[128] = t15;
    $[129] = t16;
    $[130] = t17;
    $[131] = t18;
    $[132] = t19;
    $[133] = t20;
  } else {
    t20 = $[133];
  }
  let t21;
  if ($[134] !== style || $[135] !== t13 || $[136] !== t20 || $[137] !== t5 || $[138] !== t6 || $[139] !== t7) {
    t21 = <nav aria-label={"\uD398\uC774\uC9C0 \uB0B4\uBE44\uAC8C\uC774\uC158"} className={t5} style={style}>{t6}{t7}{t13}{t20}</nav>;
    $[134] = style;
    $[135] = t13;
    $[136] = t20;
    $[137] = t5;
    $[138] = t6;
    $[139] = t7;
    $[140] = t21;
  } else {
    t21 = $[140];
  }
  return t21;
};
export interface PageNavigationProps {
  className?: string;
  title?: string | ReactNode;
  titleLeft?: string | ReactNode;
  children?: ReactNode;
  logo?: 'full' | 'symbol';
  logoHref?: string;
  searchButton?: boolean | string;
  bellButton?: boolean;
  shareButton?: boolean;
  notification?: boolean;
  settingsButton?: boolean;
  backButton?: boolean;
  backButtonType?: 'exit' | 'back';
  /** backButton 유무와 관계없이 뒤로가기 활성화 */
  enableHistoryBack?: boolean;
  kebabButton?: boolean | ReactNode;
  onClickKebab?: VoidFunction;
  hideHomeButton?: boolean;
  onClickBack?: VoidFunction | string;
  style?: React.CSSProperties;
  textColor?: string;
  isNotUsedHomeButton?: boolean;
  donationHomeButton?: boolean;
  //* 검색 폼 관련
  searchForm?: boolean;
  searchFormDefaultValue?: string;
  searchFormClassName?: string;
  onSearchFormMount?: (ref: HTMLInputElement) => void;
  onSearchFormClick?: () => void;
  onSearchFormSubmit?: (value: string) => void;
}
export const PageNavigation = props => {
  const $ = _c(70);
  const {
    logo,
    logoHref,
    title,
    titleLeft,
    children,
    backButton: t0,
    backButtonType: t1,
    enableHistoryBack,
    searchButton,
    bellButton,
    notification,
    shareButton,
    settingsButton,
    kebabButton,
    onClickBack,
    onClickKebab,
    hideHomeButton,
    className,
    style,
    textColor,
    isNotUsedHomeButton,
    donationHomeButton,
    searchForm,
    searchFormDefaultValue,
    searchFormClassName,
    onSearchFormMount,
    onSearchFormClick,
    onSearchFormSubmit
  } = props;
  const backButton = t0 === undefined ? true : t0;
  const backButtonType = t1 === undefined ? "back" : t1;
  const router = useCustomRouter();
  const {
    openConfirmModal,
    closeConfirmModal,
    confirmAndClose,
    isModalOpened
  } = useTossWebView();
  const [isKbWebview, setAppModal, isToss, isWelloApp] = useDeviceInfoStore(useShallow(_temp3));
  const isKakaobank = useCheckKakaobank();
  const isLogin = useAuthStore(_temp4);
  let t2;
  if ($[0] !== backButton || $[1] !== enableHistoryBack || $[2] !== router || $[3] !== setAppModal) {
    t2 = () => {
      const _window = window as FlutterInAppWebViewWindow;
      if (_window.router) {
        _window.router.back = backButton || enableHistoryBack ? () => router.back() : () => {
          setAppModal({
            isOpened: true,
            type: "exit"
          });
        };
        return () => {
          _window.router.back = () => router.back();
        };
      }
    };
    $[0] = backButton;
    $[1] = enableHistoryBack;
    $[2] = router;
    $[3] = setAppModal;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== backButton || $[6] !== enableHistoryBack || $[7] !== isWelloApp || $[8] !== router || $[9] !== setAppModal) {
    t3 = [backButton, enableHistoryBack, isWelloApp, router, setAppModal];
    $[5] = backButton;
    $[6] = enableHistoryBack;
    $[7] = isWelloApp;
    $[8] = router;
    $[9] = setAppModal;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
  const pathname = usePathname() ?? "";
  const shouldHideNavigation = isKbWebview && pathname !== MODULE_ROUTES.KB_HOME.pathname;
  let t4;
  if ($[11] !== backButton || $[12] !== backButtonType || $[13] !== bellButton || $[14] !== children || $[15] !== className || $[16] !== closeConfirmModal || $[17] !== confirmAndClose || $[18] !== donationHomeButton || $[19] !== enableHistoryBack || $[20] !== hideHomeButton || $[21] !== isKakaobank || $[22] !== isLogin || $[23] !== isModalOpened || $[24] !== isNotUsedHomeButton || $[25] !== isToss || $[26] !== kebabButton || $[27] !== logo || $[28] !== logoHref || $[29] !== notification || $[30] !== onClickBack || $[31] !== onClickKebab || $[32] !== onSearchFormClick || $[33] !== onSearchFormMount || $[34] !== onSearchFormSubmit || $[35] !== openConfirmModal || $[36] !== pathname || $[37] !== router || $[38] !== searchButton || $[39] !== searchForm || $[40] !== searchFormClassName || $[41] !== searchFormDefaultValue || $[42] !== settingsButton || $[43] !== shareButton || $[44] !== style || $[45] !== textColor || $[46] !== title || $[47] !== titleLeft) {
    t4 = {
      logo,
      logoHref,
      title,
      titleLeft,
      children,
      backButton,
      backButtonType,
      enableHistoryBack,
      searchButton,
      bellButton,
      notification,
      shareButton,
      settingsButton,
      kebabButton,
      onClickBack,
      onClickKebab,
      hideHomeButton,
      className,
      style,
      textColor,
      isNotUsedHomeButton,
      donationHomeButton,
      searchForm,
      searchFormDefaultValue,
      searchFormClassName,
      onSearchFormMount,
      onSearchFormClick,
      onSearchFormSubmit,
      isToss,
      isKakaobank,
      isLogin,
      pathname,
      router,
      openConfirmModal,
      closeConfirmModal,
      confirmAndClose,
      isModalOpened
    };
    $[11] = backButton;
    $[12] = backButtonType;
    $[13] = bellButton;
    $[14] = children;
    $[15] = className;
    $[16] = closeConfirmModal;
    $[17] = confirmAndClose;
    $[18] = donationHomeButton;
    $[19] = enableHistoryBack;
    $[20] = hideHomeButton;
    $[21] = isKakaobank;
    $[22] = isLogin;
    $[23] = isModalOpened;
    $[24] = isNotUsedHomeButton;
    $[25] = isToss;
    $[26] = kebabButton;
    $[27] = logo;
    $[28] = logoHref;
    $[29] = notification;
    $[30] = onClickBack;
    $[31] = onClickKebab;
    $[32] = onSearchFormClick;
    $[33] = onSearchFormMount;
    $[34] = onSearchFormSubmit;
    $[35] = openConfirmModal;
    $[36] = pathname;
    $[37] = router;
    $[38] = searchButton;
    $[39] = searchForm;
    $[40] = searchFormClassName;
    $[41] = searchFormDefaultValue;
    $[42] = settingsButton;
    $[43] = shareButton;
    $[44] = style;
    $[45] = textColor;
    $[46] = title;
    $[47] = titleLeft;
    $[48] = t4;
  } else {
    t4 = $[48];
  }
  const contentProps = t4;
  if (shouldHideNavigation) {
    return null;
  }
  const navHeightClass = searchForm && !isKakaobank ? "h-64" : "h-48";
  if (!shouldShowMobileTrendKeyword(pathname)) {
    let t5;
    if ($[49] !== navHeightClass) {
      t5 = cn("hidden mobile-tablet:block", navHeightClass);
      $[49] = navHeightClass;
      $[50] = t5;
    } else {
      t5 = $[50];
    }
    let t6;
    if ($[51] !== t5) {
      t6 = <div aria-hidden={true} className={t5} />;
      $[51] = t5;
      $[52] = t6;
    } else {
      t6 = $[52];
    }
    let t7;
    if ($[53] !== className || $[54] !== navHeightClass) {
      t7 = cn("fixed inset-x-0 top-0 z-20 hidden mobile-tablet:flex", navHeightClass, className);
      $[53] = className;
      $[54] = navHeightClass;
      $[55] = t7;
    } else {
      t7 = $[55];
    }
    let t8;
    if ($[56] !== contentProps || $[57] !== t7) {
      t8 = <PageNavigationContent {...contentProps} className={t7} />;
      $[56] = contentProps;
      $[57] = t7;
      $[58] = t8;
    } else {
      t8 = $[58];
    }
    let t9;
    if ($[59] !== t6 || $[60] !== t8) {
      t9 = <>{t6}{t8}</>;
      $[59] = t6;
      $[60] = t8;
      $[61] = t9;
    } else {
      t9 = $[61];
    }
    return t9;
  }
  let t5;
  if ($[62] !== className) {
    t5 = cn("flex", className);
    $[62] = className;
    $[63] = t5;
  } else {
    t5 = $[63];
  }
  let t6;
  if ($[64] !== contentProps || $[65] !== t5) {
    t6 = <PageNavigationContent {...contentProps} className={t5} />;
    $[64] = contentProps;
    $[65] = t5;
    $[66] = t6;
  } else {
    t6 = $[66];
  }
  let t7;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <TrendKeywordBar />;
    $[67] = t7;
  } else {
    t7 = $[67];
  }
  let t8;
  if ($[68] !== t6) {
    t8 = <div className="sticky top-0 z-20 hidden mobile-tablet:block">{t6}{t7}</div>;
    $[68] = t6;
    $[69] = t8;
  } else {
    t8 = $[69];
  }
  return t8;
};
function _temp(state) {
  return [state.isExitConfirmOpened, state.openExitConfirm, state.closeExitConfirm];
}
function _temp2() {
  openShareDrawer(location.href);
}
function _temp3(state) {
  return [state.webviewType === WEBVIEW_TYPE.KB_PAY, state.setAppModal, state.subDomain === SUB_DOMAIN.TOSS, state.webviewType === WEBVIEW_TYPE.WELLO_APP] as const;
}
function _temp4(state_0) {
  return state_0.isLogin;
}